import React, { useEffect, useState } from "react";
import { IPetsyQuoteNumberProps } from "./PetsyQuoteNumber.types";
import { Modal, Button, Image } from "react-bootstrap";
import "./PetsyQuoteNumber.scss";
import {
  subscribeDataChange,
  unsubscribeDataChange,
  useFlowData,
  TickBox,
  TextMask,
  IFlowFormControlDataChange,
  setFlowDataDirect,
  getFlowDataDirect,
  logEvent,
} from "@adaptis/flow-components";
import { sendSmsMessage } from "../../util/data-store";
import _ from "lodash";
import { sendEmail } from "../../util/knose-api-wrapper";
import { getAFXProfile } from "../../util/helper-functions";

export default function PetsyQuoteNumber(props: IPetsyQuoteNumberProps) {
  const [quoteNumber, setQuoteNumber] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  const instanceId = React.useMemo(() => guidGenerator(), []);
  const emailValidationPattern = `[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.+[A-Za-z]{2,63}$`;
  const [isInvalidEmail, setIsInvalidEmail] = React.useState<boolean>(true);
  const [isTouchedEmail, setIsTouchedEmail] = React.useState<boolean>(false);
  const [enableButton, setEnableButton] = React.useState<boolean>(false);
  const [shake, setShake] = React.useState<boolean>(false);
  const { setData, getData } = useFlowData();
  const [tableKey, setTableKey] = useState(1);
  const [emailInitialValue, setEmailInitialValue] = useState("");
  const [phoneInitialValue, setPhoneInitialValue] = useState("");
  const [renderKey, setRenderKey] = React.useState(0);
  const [currentPet, setCurrentPet] = React.useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const countdownRef = React.useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const petId = getData("id");
    let allPets = getFlowDataDirect("pets");
    if (!allPets) return;
    if (petId) {
      allPets.forEach((pet: any) => {
        if (pet != undefined && pet.id === petId) {
          setCurrentPet(pet);
          if (pet?.customCover?.quoteNumber) {
            setQuoteNumber(pet.customCover.quoteNumber);
          }
          return;
        }
      });
    } else if (allPets.length > 0) {
      setCurrentPet(allPets[0]);
      if (allPets[0].customCover.quoteNumber) {
        setQuoteNumber(allPets[0].customCover.quoteNumber);
      }
    }
  }, []);

  useEffect(() => {
    // Anything in here is fired on component mount.
    const eventName = `QuoteNumberChange_${instanceId}`;
    if (getData("quoteNumber")) {
      setQuoteNumber(getData("quoteNumber"));
    }
    subscribeDataChange(eventName, handleQuoteNumberChange);

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange(eventName);
    };
  }, []);

  useEffect(() => {
    setTableKey(tableKey + 1);
  }, [quoteNumber]);

  function handleQuoteNumberChange(dataPath: string, dataField: string, data: any) {
    if (dataField === "quoteNumber") {
      setQuoteNumber(data);
    }
  }

  function modalClose() {
    setIsTouchedEmail(false);
    setShowModal(false);
    setEnableButton(false);
    setShake(false);
    setIsLoading(false);
    setIsSuccess(false);
    setIsError(false);
    setCountdown(0);
    if (countdownRef.current) clearInterval(countdownRef.current);
  }

  function modalOpen() {
    setShowModal(true);
    setShake(false);

    setFlowDataDirect("sendQuoteToPhone", "");

    let quoteEmailAddress = getData("root.holderEmail") ?? "";
    // let emailPopupValue = getData("root.sendQuoteToEmail");
    if (quoteEmailAddress) {
      setFlowDataDirect("sendQuoteToEmail", quoteEmailAddress);
    }
    // if (
    //   (emailPopupValue == "" || emailPopupValue == undefined) &&
    //   quoteEmailAddress != "" &&
    //   quoteEmailAddress != undefined
    // ) {
    //   setFlowDataDirect("sendQuoteToEmail", quoteEmailAddress);
    // }
    // else
    // {
    //   setFlowDataDirect("sendQuoteToEmail", "");
    // }

    setEmailInitialValue(getData("root.sendQuoteToEmail"));
    setPhoneInitialValue(getData("root.holderPhone"));
    setFlowDataDirect("sendQuoteToPhone", getData("root.holderPhone"));
    checkInputsIfValid();
  }

  const optionRef = React.useRef<any>();

  function handleScrollToElement() {
    optionRef.current.childNodes[8].scrollIntoView();
  }

  function handleSaveClick(e: any) {
    e.preventDefault();
    modalOpen();
  }

  async function handleSendQuote() {
    setIsLoading(true);
    setIsError(false);
    try {
      let sendQuoteToEmail = getFlowDataDirect("sendQuoteToEmail") ?? "";
      let sendQuoteToPhone = getFlowDataDirect("sendQuoteToPhone") ?? "";
      let quoteNo = getFlowDataDirect("quoteNo") ?? "";
      let mmSessionId = getFlowDataDirect("mmSessionId") ?? "";
      let firstName = getFlowDataDirect("holderFirstName");
      let petName = currentPet ? currentPet.name : "";
      let quoteNumber = currentPet ? currentPet.customCover.quoteNumber : "";
      let quoteNumberParent = currentPet ? currentPet.customCover.parentQuoteNumber : "";
      let petBreed = currentPet ? currentPet.breed : "";

      const promises: Promise<any>[] = [];
      if (sendQuoteToEmail && quoteNo) {
        promises.push(sendEmail(mmSessionId) as Promise<any>);
      }
      if (sendQuoteToPhone && quoteNo) {
        promises.push(
          sendSmsMessage({
            source: "Costco",
            firstName,
            petName,
            petBreed,
            sendQuoteToPhone,
            quoteNo,
            quoteNumber,
            quoteNumberParent,
          }) as Promise<any>
        );
      }
      await Promise.all(promises);

      logEvent("save-quote-fields", true, getAFXProfile());
      setIsSuccess(true);
      setIsLoading(false);
      setCountdown(30);
      if (countdownRef.current) clearInterval(countdownRef.current);
      countdownRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            if (countdownRef.current) clearInterval(countdownRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      setCountdown(30);
      if (countdownRef.current) clearInterval(countdownRef.current);
      countdownRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            if (countdownRef.current) clearInterval(countdownRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }

  useEffect(() => {
    return () => {
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, []);

  async function submit() {
    checkInputsIfValid();
    setShake(false);
    if (enableButton) {
      setFlowDataDirect("holderEmail", getData("root.sendQuoteToEmail"));
      setFlowDataDirect("holderPhone", getData("root.sendQuoteToPhone"));
      await handleSendQuote();
    } else {
      setShake(true);
      setRenderKey((renderKey) => renderKey + 1);
      handleScrollToElement();
    }
  }

  function checkInputsIfValid() {
    setShake(false);

    let phone = getData("root.sendQuoteToPhone") ?? "";
    let email = getData("root.sendQuoteToEmail") ?? "";
    // let agreeToBeContacted = getData("root.sendQuoteAgreeToBeContacted") ?? "";

    // if (!agreeToBeContacted) {
    //   setEnableButton(false);
    //   return;
    // }
    let invalidEmail = true;
    if (email) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        invalidEmail = true;
        setEnableButton(false);
        setShake(false);
        return;
      } else {
        invalidEmail = false;
      }
    }

    let invalidPhone = true;
    if (phone.length == 10) {
      invalidPhone = false;
    }

    if (!invalidPhone && phone.length == 10 && email == "") {
      setEnableButton(true);
    } else if (!invalidEmail && email != "" && phone == "") {
      setEnableButton(true);
    } else if (!invalidPhone && !invalidEmail && email != "" && phone.length == 10) {
      setEnableButton(true);
    } else {
      setEnableButton(false);
      setShake(true);
    }
  }

  function handleOnChangePhone(dataChange: IFlowFormControlDataChange) {
    setFlowDataDirect("sendQuoteToPhone", dataChange.value);
    checkInputsIfValid();
  }

  function handleOnChangeAgreeToBeContacted(isChecked: boolean) {
    setFlowDataDirect("sendQuoteAgreeToBeContacted", isChecked);
    checkInputsIfValid();
  }

  function handleOnBlurPhone(dataChange: IFlowFormControlDataChange) {
    checkInputsIfValid();
  }

  function guidGenerator() {
    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
  }

  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  const paramTextMask = {
    id: "numPhone",
    prompt: "Enter your Mobile Number",
    minLength: 12,
    maxLength: 12,
    required: false,
    type: "text-mask",
    mask: "phone",
    dataField: "sendQuoteToPhone",
    invalidMessage: "",
    onChange: handleOnChangePhone,
    onBlur: handleOnBlurPhone,
  };

  return (
    <>
      {quoteNumber && (
        <div
          key={guidGenerator()}
          data-testid="PetsyQuoteNumber"
          id={guidGenerator().toString()}
          className={
            "flc_petsy-quote-number " +
            (props.className ?? "") +
            (props.showDivWithIcon ? " show-div-with-icon" : "")
          }
        >
          {(props.showQuoteBox != undefined ? props.showQuoteBox : false) && (
            <div className="quote-number ">Quote number: {quoteNumber}</div>
          )}

          {props.showSaveMyQuote && (
            <div className="save-quote-number">
              {props.showDivWithIcon && (
                <div className="save-quote-sticky-header d-flex" onClick={handleSaveClick}>
                  <div className="d-inline-flex align-items-center">
                    <Image src="/images/icons/save.svg" />
                  </div>
                  <span>{props.textLabel ? props.textLabel : "Save & Send"}</span>
                </div>
              )}
              {!props.showDivWithIcon && (
                <div className="save-my-quote">
                  <a href="#" onClick={handleSaveClick}>
                    <span>
                      <strong>{props.textLabel ? props.textLabel : "Save & Send My Quote"}</strong>
                    </span>
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      <Modal
        className="flc_petsy-save-quote-number"
        show={showModal}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="text-center" ref={optionRef}>
          <div>
            <Image className="" src="/images/Paws_continue_later.svg" />
          </div>
          <div className="modal-text text-style-2">Paws & continue later</div>
          <div className="modal-text text-style-3">
            Please enter your email address or mobile number and we will send you a link to continue
            your application whenever you're ready.
          </div>
          <br />

          <div className={"form-floating"}>
            <input
              name="sendQuoteToEmail"
              placeholder="Email address"
              aria-describedby="textHelpBlock"
              id="textEmailAddress"
              value={emailInitialValue}
              // readOnly={true}
              className={
                "form-control " +
                (isTouchedEmail ? (isInvalidEmail ? " is-invalid" : "is-valid") : "")
              }
              type="email"
              pattern={emailValidationPattern}
              onChange={(e) => {
                setIsInvalidEmail(e.target.checkValidity() === false);
                setIsTouchedEmail(true);
                if (e.target.value == "") setIsTouchedEmail(false);

                setFlowDataDirect("sendQuoteToEmail", e.target.value);
                setEmailInitialValue(getData("root.sendQuoteToEmail"));
                checkInputsIfValid();
              }}
              onBlur={(e) => {
                e.preventDefault();

                if (e.target.value == "") setIsTouchedEmail(false);

                checkInputsIfValid();
              }}
            />
            <div className="invalid-feedback"></div>
            <label>Email address</label>
          </div>

          <label className="my-3 or">and / or</label>

          <br />
          <TextMask {...paramTextMask} value={phoneInitialValue} />

          {/* {!(isSuccess || isLoading) && (
            <TickBox
              stepSlug={""}
              labelHTML="I want to receive a phone call from Petsy about Petsy Pet Insurance."
              onChange={handleOnChangeAgreeToBeContacted}
            />
          )} */}

          {isLoading ? (
            <div className="my-4 d-flex flex-column align-items-center justify-content-center">
              <div className="spinner-border text-primary mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span>Sending...</span>
            </div>
          ) : isSuccess ? (
            <div className="mt-4">
              <div className="modal-text text-style-2" style={{ color: "#1e9c6b" }}>
                Your link is on its way!
              </div>
              <div className="modal-text text-style-3">
                Please check your email or SMS for a link to continue your application whenever
                you're ready.
                <br />
                Didn't get it? Check your spam or junk folder, or click resend below.
              </div>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button
                  variant="primary"
                  className={`${countdown > 0 || isLoading ? `btn-gray` : "btn-primary"}`}
                  onClick={handleSendQuote}
                  disabled={countdown > 0 || isLoading}
                >
                  {countdown > 0 ? `Resend link (${countdown})` : "Resend link"}
                </Button>
                <Button variant="primary" onClick={modalClose}>
                  Close
                </Button>
              </div>
            </div>
          ) : (
            <Button
              key={renderKey}
              disabled={!enableButton || countdown > 0 || isLoading}
              className={
                "flc_next-button btn mt-3 py-3 mt-4 btn-" +
                (enableButton ? "primary" : "primary ") +
                (shake ? " shake-button" : "")
              }
              onClick={submit}
            >
              {countdown > 0 ? `Save and continue later (${countdown})` : "Save and continue later"}
            </Button>
          )}
          {isError && !isSuccess && (
            <div className="text-danger mt-2">An error occurred, please try again!</div>
          )}
          <div className="mt-3 modal-text text-style-4">
            By providing your contact details including your phone number, you consent to Petsy
            contacting you regarding your pet insurance quote and to assist with any questions you
            may have. By proceeding to obtain a quote you agree that you understand and accept the
            <a className="modal-text text-link" target="_blank" href="https://petsy.com.au/website-terms-of-use/">
              Terms & Conditions
            </a>
            ,{" "}
            <a
              className="modal-text text-link"
              target="_blank"
              href="https://insurance-documents.petsy.com.au/petsy/petsy-fsg.pdf"
            >
              Financial Services Guide
            </a>
             ,
            <a
              className="modal-text text-link"
              target="_blank"
              href="https://petsy.com.au/privacy-policy/"
              style={{ marginRight: "5px" }}
            >
              Privacy Policy
            </a>
             and agree to our use of cookies. We may pay referral fees or benefits to individuals or
            organisations that refer new customers to Petsy.
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
